/*
existing-user-check-api.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('existingUserCheckApi',['angular'], function () {

    // Module Dependencies
    var dependencies = [];

    // Module Definition
    var mod = angular.module('Services.ExistingUserCheckApi', dependencies);

    /**
     * @name existingUserCheckApi
     * @type factory
     *
     * @description
     * A factory that provides methods for checking users existence in Centricity360.
     */
    mod.factory('existingUserCheckApi', ['$q', '$log', function ($q, $log) {
        /**
         * Base url for requests to the User Existance check REST API.
         */
        var USER_CHECK = '/v1/umgmt/guest/users';
        var EMAIL_CHECK = '/validateEmail';

        /**
         * Checks for user existence in Centricity360.
         *
         * @param email
         *    The email added by user.
         *
         * @param settings.async
         *    By default, all requests are sent asynchronously (i.e. this is set to true by default).
         *    If you need synchronous requests, set this option to false. Please note that synchronous
         *    requests may temporarily lock the browser, disabling any actions while the request is active.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function checkUserExistance(email, signature, invitationCode, selfRegistration) {
            // validate arguments
            if (!email) {
                var errorMsg = 'Error: userExistanceCheckApi: checkUserExistance: invalid parameter: email = ' + email;
                $log.error(errorMsg);
                return $q.reject(errorMsg);
            }

            var deferred = $q.defer();
            var ajaxOptions = {
                // TODO: Remove Header once Authorization is in place
                async: true,
                type: 'get',
                success: success,
                error: error
            };
            var url = '';
            if (!selfRegistration) {
                url = USER_CHECK + '?email=' + encodeURIComponent(email) + '&status=pending&invitationCode=' + invitationCode + '&js-sig=' + signature;
                ajaxOptions.dataType = 'json';
            } else {
                url = EMAIL_CHECK + '/' + email;
            }
            ajaxOptions.url = url;

            // send the request
            $.ajax(ajaxOptions);

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                $log.log('Success: userExistanceCheckApi: GET "' + url + '"');
                var response = data || null;
                deferred.resolve(response, jqXHR.getResponseHeader('js-sig'));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: userExistanceCheckApi: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }


        /**
         * Matches the user details like first name, last name and mobile number with the one entered by admin.
         *
         * @param firstname
         *    The first name added by user.
         *
         * @param lastname
         *    The last name added by user.
         *
         * @param mobileNumber
         *    The mobile number added by user.
         *
         * @param signature
         *    The js-sig signature to be sent to API for security.
         *
         * @param invitationCode
         *    The invitationCode got from the email / URI.
         *
         * @param validationFlag
         *    The validationFlag for external authentication is verified successfully or not.
         *
         * @return
         *    A promise that will be resolved/rejected once a response is received.
         */
        function validateUserIdentity(firstName, lastName, mobileNumber, signature, invitationCode, validationFlag) {
            // validate arguments
            if (validateArguments(firstName, lastName, mobileNumber, signature, invitationCode)) {
                var errorMsg;
                if (!firstName) {
                    errorMsg = 'Error: userExistanceCheckApi: validateUserIdentity: invalid parameter: firstName';
                } else if (!lastName) {
                    errorMsg = 'Error: userExistanceCheckApi: validateUserIdentity: invalid parameter: lastName';
                } else if (!mobileNumber) {
                    errorMsg = 'Error: userExistanceCheckApi: validateUserIdentity: invalid parameter: mobileNumber';
                } else if (!signature) {
                    errorMsg = 'Error: userExistanceCheckApi: validateUserIdentity: invalid parameter: signature';
                } else if (!invitationCode) {
                    errorMsg = 'Error: userExistanceCheckApi: validateUserIdentity: invalid parameter: invitationCode';
                }
                $log.error(errorMsg);
                return $q.reject(errorMsg);
            }


            var deferred = $q.defer(),
                url = USER_CHECK + '?firstName=' + encodeURIComponent(firstName) + '&lastName=' + encodeURIComponent(lastName) + '&mobile=' + encodeURIComponent(mobileNumber) + '&invitationCode=' + invitationCode + '&js-sig=' + signature + '&clinicianLicenseNumberVerified=' + validationFlag;

            // send the request
            $.ajax({
                async: true,
                dataType: 'json',
                type: 'get',
                url: url,
                cache: false,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                $log.log('Success: validateUserIdentity: GET "' + url + '"');
                var response = data || null;
                deferred.resolve(response, jqXHR.getResponseHeader('js-sig'));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: validateUserIdentity: GET "' + url + '" (failed): ' + errorThrown;
                if (jqXHR.status === 412) {
                    errorMsg = jqXHR.responseJSON.message;
                }
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }

        }

        function validateArguments(firstName, lastName, mobileNumber, signature, invitationCode){
            return !firstName || !lastName || !mobileNumber || !signature || !invitationCode;
        }

        /**
         * Gets config values from the application.conf
         *
         */
        function getConfigValues() {
            var deferred = $q.defer(),
                url = "/getConfigValues";

            // send the request
            $.ajax({
                async: true,
                dataType: 'json',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                $log.log('Success: getConfigValues: GET "' + url + '"');
                var response = data || null;
                deferred.resolve(response, jqXHR.getResponseHeader('js-sig'));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: getConfigValues: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }
        }

        function getUserUID() {
            var deferred = $q.defer(),
                url = "/getUserUID";

            // send the request
            $.ajax({
                async: true,
                dataType: 'text',
                type: 'get',
                url: url,
                success: success,
                error: error
            });

            return deferred.promise;

            function success(data, textStatus, jqXHR) {
                $log.log('Success: getUserUID: GET "' + url + '"');
                var response = data || null;
                deferred.resolve(response, jqXHR.getResponseHeader('js-sig'));
            }

            function error(jqXHR, textStatus, errorThrown) {
                var errorMsg = 'Error: getUserUID: GET "' + url + '" (failed): ' + errorThrown;
                $log.error(errorMsg);
                deferred.reject(errorMsg);
            }
        }


        /**
         * Public API
         */
        return {
            checkUserExistance: checkUserExistance,
            validateUserIdentity: validateUserIdentity,
            getConfigValues: getConfigValues,
            getUserUID: getUserUID
        };

    }]);

});

